import jsCookie from 'js-cookie';
import utm from './utm';
import tomiAI from './tomiAI';
import httpRequest from '../httpRequest';
import errorHandler from '../errorHandler';

const sendLeads = async (data) => {
  const windowDefined = typeof window !== 'undefined';
  const UTM = windowDefined ? utm.getAll() : {
  };
  const gaId = windowDefined && tomiAI.getGaId();

  if (gaId) {
    UTM.ga_id = gaId;
  }

  const defineLandingPage = () => {
    const landingCookie = jsCookie.get('landing_page');

    if (landingCookie) {
      return landingCookie;
    }
    return windowDefined ? window.location.pathname : '';
  };

  const payload = {
    category: data.category,
    phone_number: data.phoneNumber,
    ...(data.email
      ? {
        email: data.email
      }
      : {
      }),
    ...(data.firstName
      ? {
        first_name: data.firstName
      }
      : {
      }),
    ...(data.lastName
      ? {
        last_name: data.lastName
      }
      : {
      }),
    lead_info_data: {
      ...(data.age
        ? {
          age: data.age.toString()
        }
        : {
        }),
      ...(data.gender
        ? {
          gender: data.gender
        }
        : {
        }),
      ...(data.email
        ? {
          email: data.email
        }
        : {
        }),
      source: 'content-ui',
      landing_page: defineLandingPage(),
      conversion_page: windowDefined ? window.location.pathname : ''
    },
    ...(Object.keys(UTM).length
      ? {
        utm_data: UTM
      }
      : {
      })
  };

  try {
    const res = await httpRequest(`${process.env.GATSBY_LEADS_BASE_URL}v1/leads`, {
      method: 'POST',
      body: JSON.stringify(payload)
    });

    return res;
  } catch (err) {
    const res = errorHandler(err);
    return res;
  }
};

export default sendLeads;
